import { render } from "./AllNewsdownload.vue?vue&type=template&id=67247572&scoped=true"
import script from "./AllNewsdownload.vue?vue&type=script&lang=js"
export * from "./AllNewsdownload.vue?vue&type=script&lang=js"

import "./AllNewsdownload.vue?vue&type=style&index=0&id=67247572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67247572"]])

export default __exports__